const howItWorksSteps = [
  {
    number: "1.",
    title: "Send a reel",
    body: "DM any Instagram recipe to SendToChef.",
  },
  {
    number: "2.",
    title: "Get a real recipe",
    body: "We turn it into clean ingredients and step-by-step instructions, saved and ready to use.",
  },
  {
    number: "3.",
    title: "Decide together",
    body: "Browse your family's recipes in one place and use the meal decider to choose what's for dinner.",
  },
];

export function LandingHowItWorksSection() {
  return (
    <section className="border-t border-black/8 px-4 pt-8 pb-12 sm:px-6 sm:pt-10 sm:pb-14 lg:px-8 lg:pt-12 lg:pb-20">
      <div className="mx-auto max-w-5xl">
        <div className="max-w-[20rem] sm:max-w-[30rem]">
          <p className="text-[11px] font-semibold tracking-[0.18em] text-[#7f7468] uppercase">
            How it works
          </p>

          <h2 className="mt-4 text-[2.7rem] leading-[0.92] font-semibold tracking-[-0.04em] text-black sm:text-[4rem]">
            Three simple steps from reel to dinner.
          </h2>
        </div>

        <div className="mt-8 grid gap-8 sm:mt-10 sm:grid-cols-3 sm:gap-6 lg:gap-8">
          {howItWorksSteps.map((step) => (
            <article
              key={step.number}
              className="border-t border-black/8 pt-6 sm:pt-7"
            >
              <div className="min-w-0">
                <h3 className="text-[1.35rem] leading-[1.02] font-semibold tracking-[-0.03em] text-black sm:text-[1.55rem]">
                  <span className="mr-2">{step.number}</span>
                  {step.title}
                </h3>

                <p className="mt-3 text-[15px] leading-7 text-[#5f564b] sm:text-base">
                  {step.body}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
